// extracted by mini-css-extract-plugin
module.exports = {"container":"BottomTray_container__ou5Ev","opacScreen":"BottomTray_opacScreen__O5_v0","tray":"BottomTray_tray__xY3dR"};